import type { TerrainOnlyTileKind, Tile } from "@dailywars/core/engine";
import { mapThemeConfig, type MapTheme } from "@dailywars/core/render/mapThemes";

import { drawBuildingImage } from "#/game/buildingDraw";
import { resolveDropZoneOverlayImages } from "#/game/dropZoneSprites";
import { isImageReady } from "#/game/imageReady";
import { getTerrainImage } from "#/game/svgAssets";
import { getSpriteTerrainImage } from "#/game/terrainSprites";

function drawFilledTile({
  ctx,
  px,
  py,
  tileSize,
  fillStyle,
}: {
  ctx: CanvasRenderingContext2D;
  px: number;
  py: number;
  tileSize: number;
  fillStyle: string;
}): void {
  ctx.fillStyle = fillStyle;
  ctx.fillRect(px, py, tileSize, tileSize);
}

function drawDropZoneOverlays({
  ctx,
  x,
  y,
  tileSize,
  tiles,
  width,
  theme,
}: {
  ctx: CanvasRenderingContext2D;
  x: number;
  y: number;
  tileSize: number;
  tiles: readonly Tile[];
  width: number;
  theme: MapTheme;
}): void {
  for (const overlayImg of resolveDropZoneOverlayImages({ tiles, width, x, y, theme })) {
    if (!isImageReady(overlayImg)) continue;
    drawBuildingImage({ ctx, img: overlayImg, tileX: x, tileY: y, tileSize });
  }
}

export function drawOverlaySpriteTerrainTile({
  ctx,
  kind,
  x,
  y,
  px,
  py,
  theme,
  tileSize,
  tiles,
  width,
}: {
  ctx: CanvasRenderingContext2D;
  kind: TerrainOnlyTileKind;
  x: number;
  y: number;
  px: number;
  py: number;
  theme: MapTheme;
  tileSize: number;
  tiles?: readonly Tile[];
  width?: number;
}): void {
  const plainImg = getTerrainImage({ kind: "plain", x, y, theme });
  if (isImageReady(plainImg)) {
    ctx.drawImage(plainImg, px, py, tileSize, tileSize);
  } else {
    drawFilledTile({
      ctx,
      px,
      py,
      tileSize,
      fillStyle: mapThemeConfig(theme).plainColors[0],
    });
  }
  const overlayImg = getSpriteTerrainImage({ theme, kind });
  if (isImageReady(overlayImg)) {
    drawBuildingImage({ ctx, img: overlayImg, tileX: x, tileY: y, tileSize });
  }
  if (kind === "dropZone" && tiles !== undefined && width !== undefined) {
    drawDropZoneOverlays({ ctx, x, y, tileSize, tiles, width, theme });
  }
}
